export default `
  mutation tagWorkflowVersion($projectId: String!, $workflowId: String!, $version: Int!, $tag: String) {
    tagWorkflowVersion(projectId: $projectId, workflowId: $workflowId, version: $version, tag: $tag) {
      id
      version
      tag
      updatedAt
    }
  }
`
